(function () {
    'use strict';

    angular.module('app').factory('ReceiptService', ReceiptService);
    ReceiptService.$inject = ['$rootScope', '$http'];

    function ReceiptService($rootScope, $http) {
        var service = {};
        service.apiUrl = $rootScope.appConfig.workers.invoices;

        service.getView = function (receipt, callback) {
            $http({
                method: 'POST',
                url: `${service.apiUrl}/view/receipt`,
                data: receipt
            }).then(function successCallback(data) {
                callback(true, data);
            }, function errorCallback(data) {
                callback(false, data);
            });
        };

        service.getPdf = function (receipt, isCopyCustomer, callback) {
            $http({
                method: 'POST',
                url: `${service.apiUrl}/api/create_receipt?type=${isCopyCustomer ? 'customer': 'business'}`,
                data: receipt
            }).then(function successCallback(data) {
                callback(true, data);
            }, function errorCallback(data) {
                callback(false, data);
            });
        };

        service.getCouponView = function (code, params, callback) {
            $http({
                method: 'GET',
                url: `${service.apiUrl}/view/coupon/${code}?` + paramsToUrlQueryEncodeURIComponent(params),
            }).then(function successCallback(data) {
                callback(true, data);
            }, function errorCallback(data) {
                callback(false, data);
            });
        };

        service.getCouponPdf = function (code, params, callback) {
            $http({
                method: 'GET',
                url: `${service.apiUrl}/api/generate_coupon/${code}?` + paramsToUrlQueryEncodeURIComponent(params),
            }).then(function successCallback(data) {
                callback(true, data);
            }, function errorCallback(data) {
                callback(false, data);
            });
        };

        return service;
    }

})();
